<template>
  <el-tabs v-model="workflowName" style="width: 90%;margin: auto">
    <el-tab-pane label="审核情况" name="one">
      <el-table
        v-loading="configworkflow.loading"
        :element-loading-text="configworkflow.loadtext"
        :data="workflowData"
        border
        stripe
        :height="configworkflow.height"
        :max-height="configworkflow.maxHeight"
        highlight-current-row
        style="width: 100%; overflow-y: auto;"
        :header-cell-style="{background:'#F8FCFF',color:'#606266'}"
        size="mini"
      >
        <el-table-column
          v-for="item in workflowLabel"
          v-if="!(item.isShow || item.isShow === 'false')"
          :key="item.prop"
          :sortable="item.sortable"
          :label="item.label"
          :fixed="item.fixed"
          :width="item.width ? item.width : ''"
          :align="item.aligin ? item.aligin : 'center'"
          header-align="center"
          show-overflow-tooltip
        >
          <!-- eslint-disable-next-line -->
          <template  slot="header" slot-scope="scope">
            <div style="line-height: 14px;"> {{ item.label }}</div>
            <div v-if="configworkflow.searchTables">
              <el-divider></el-divider>
              <el-date-picker
                v-if="item.type === 'Date'"
                v-model="item.search"
                size="mini"
                clearable
                type="daterange"
                align="left"
                unlink-panels
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                :picker-options="pickerOptions"
                style="width:100%"
                format="yyyy 年 MM 月 dd 日"
                value-format="yyyy-MM-dd"
                @change="dateChangeEvent">
              </el-date-picker>
              <el-input
                v-else
                v-model="item.search"
                size="mini"
                clearable
                prefix-icon="el-icon-search"
                style="line-height: 24px;"
                @keyup.enter.native="searchTable()"></el-input>
            </div>
          </template>
          <template slot-scope="scope">
            <el-link v-if="item.click" type="primary">{{ scope.row[item.prop] }}</el-link>
            <span v-else style="text-align: center;">{{ scope.row[item.prop] }}</span>
          </template>
        </el-table-column>
      </el-table>
    </el-tab-pane>
    <el-tab-pane label="个人借款明细" name="two" style="width: 100%">
      <div>
        <div>
          <span>借款人借款情况：</span>
        </div>
        <table style="width: 100%;margin-bottom: 5px;margin-top: 5px;padding: 3px;text-align: center">
          <col style="width: 10%">
          <col style="width: 23%">
          <col style="width: 10%">
          <col style="width: 23%">
          <col style="width: 10%">
          <col style="width: 23%">
          <tr>
            <td>累计借款</td>
            <td><span v-text="Grmxljjk"></span></td>
            <td>已还款</td>
            <td><span v-text="Grmxyjk"></span></td>
            <td>借款余额</td>
            <td><span v-text="Grmxjkye"></span></td>
          </tr>
        </table>
        <div>
          <span>个人明细：</span>
        </div>
        <table style="width: 100%;margin-bottom: 5px;margin-top: 5px;padding: 3px;text-align: center">
          <col style="width: 10%">
          <col style="width: 20%">
          <col style="width: 15%">
          <col style="width: 15%">
          <col style="width: 15%">
          <col style="width: 15%">
          <col style="width: 10%">
          <tr>
            <td>日期</td>
            <td>摘要</td>
            <td>凭证号</td>
            <td>票据号</td>
            <td>借款</td>
            <td>还款</td>
            <td>余额</td>
          </tr>
          <tr>
            <td>期初</td>
            <td>上年结转</td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td>0.00</td>
          </tr>
          <tr>
            <td>期末</td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
          </tr>
        </table>
      </div>
    </el-tab-pane>
  </el-tabs>
</template>

<script>
export default {
  /*props: {
    property: Array
  },*/
  data() {
    return {
      configworkflow: {
        fixed: false,
        sizes: [15, 25, 35],
        dataTotalCount: 0,
        pageSize: 15,
        currentPage: 1,
        loading: false,
        searchTables: false,
        // height: '20vh',
        indexWidth: '100%'
      },
      workflowData: [],
      workflowName: 'one',
      workflowLabel: [
        {
          label: '类别',
          prop: 'lb',
          width: '85',
          aligin: 'center'
        },
        {
          label: '日期',
          prop: 'rq',
          width: '60',
          aligin: 'center'
        },
        {
          label: '报销人',
          prop: 'bxr',
          width: '85',
          aligin: 'center'
        },
        {
          label: '出差日期/报销内容',
          prop: 'bz',
          aligin: 'center'
        },
        {
          label: '报销金额',
          prop: 'bxje',
          width: '100',
          aligin: 'center'
        }
      ],
      Grmxljjk: '0.00',
      Grmxyjk: '0.00',
      Grmxjkye: '0.00'
    }
  },
  created() {

    for (let i = 0; i < 3; i++) {
      const lbName = ['出差报销', '费用报销', '报销总计']
      const item = {
        lb: lbName[i],
        rq: i < 2 ? '合计' : '',
        bxr: '',
        bz: '',
        bxje: ''
      }
      this.workflowData.push(item)
    }
  }
}
</script>

<style scoped>
  table,table tr th, table tr td {
    border:1px solid #000000;
  }

</style>
